module.exports = __webpack_public_path__ + "static/media/flightdeckvets.73971c6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/flightdeckvets.png
// module id = 99
// module chunks = 0